<h3 class="mwl-sm-5">Locate your membership</h3>
<div class="locate-tab-container">
  <nav mat-tab-nav-bar class="locate-tabs" [tabPanel]="tabPanel">
    <a
      mat-tab-link
      *ngFor="let link of links"
      (click)="changeLocateStep.emit(link.step)"
      (keyup.enter)="changeLocateStep.emit(link.step)"
      (keydown.enter)="$event.preventDefault()"
      [attr.aria-label]="link.title"
      [ngClass]="currentStep == link.step ? 'border' : ''"
    >
      {{ link.title }}
    </a>
  </nav>
</div>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
